import { chain, includes } from "lodash"
import { Creators as SegmentsCreator } from "modules/compare-segments-root/model"
import { Creators as ComparisonCreators } from "modules/comparison/model"
import { getSegmentNormalization, NORMALIZATION } from "helpers/segments"

export function getItemActions(item, nbItems, longShortData) {
  const isContributor = getSegmentNormalization(item) === NORMALIZATION.CONTRIBUTION
  const actions = [{
    condition: !item.initialItem,
    action: {
      group: 0,
      label: "Remove",
      fn: () => SegmentsCreator.removeComparisonItem(item, "compare-remove-comparison"),
    },
  }, {
    condition: !item.segment && includes(["security", "swap"], item.type),
    action: {
      group: 0,
      label: `Evaluate As ${item.evaluateAs === "short" ? "Long" : "Short"}`,
      disabled: item.isUnmodeled,
      fn: () => ComparisonCreators.evaluateAs(item),
    },
  }, {
    condition: longShortData && !item.segment,
    action: {
      group: 1,
      label: "Split into LONG/SHORT",
      fn: () => SegmentsCreator.splitItem(item, "compare-split-item"),
      disabled: nbItems > 3,
      disabledTooltip: "There is not enough space to add the 2 segments",
    },
  }, {
    condition: item.segment,
    action: {
      label: `Normalize As ${isContributor ? "Standalone" : "Contributor"}`,
      fn: () => SegmentsCreator.setSegmentNormalization(item, isContributor ? NORMALIZATION.STANDALONE : NORMALIZATION.CONTRIBUTION, "compare-set-segment-normalization"),
    },
  }]
  return chain(actions)
    .filter(({ condition }) => condition)
    .map(({ action }) => action)
    .value()
}
